import { TickCircle } from "iconsax-react";
import React from "react";

const GuestCard = ({ data, onClick }) => {
  return (
    <div
      className="flex flex-col w-full p-[16px] font-normal text-[14px] bg-white hover:bg-[#F7F8FA] hover:cursor-pointer rounded-xl gap-1"
      onClick={onClick}
    >
      <div className="flex flex-col w-full font-normal gap-[8px] items-center">
        <div className="flex items-center w-full justify-between">
          <h2>
            {data.salutation && `${data.salutation}. `}
            {data.name}
          </h2>
          {data.status && (
            <div className="flex w-fit rounded-md px-[8px] gap-[4px] items-center bg-[#F4FCF7] border border-[#E9F9EF] text-[#22C55E] text-[11px]">
              <TickCircle size="11" variant="Bold" />
              Checked
            </div>
          )}
        </div>
        <div className="flex w-full gap-[4px]">
          <p className="text-[#636C7E]">
            {[data.email, data.contact, data.group_name]
              .filter(Boolean)
              .join(" / ")}
          </p>
        </div>
      </div>
      {data.tags && data.tags.length > 0 && (
        <div className="flex flex-wrap gap-[4px]">
          {data.tags.map((tag, index) => (
            <span
              key={index}
              className="text-[11px] font-medium px-[8px] py-[4px] rounded-md"
              style={{
                backgroundColor: tag.color + "30",
                color: tag.color,
              }}
            >
              {tag.name}
            </span>
          ))}
        </div>
      )}
    </div>
  );
};

export default GuestCard;
